export const truncateString = (str: string, num: number) => (str.length > num ? str.substr(0, num) + '...' : str);

export const convertToKebabCase = (str: string) => str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);

export const stringToNumber = (str: string) => {
    const parsed = parseFloat(str);
    return isNaN(parsed) ? 0 : parsed;
};
